var i18n = {
  dict: null,
  setDictionary: function(i18n_dict) {
    this.dict = i18n_dict;
  },
  _: function (str, params) {
    var transl = str;
    if (this.dict && this.dict[str]) {
      transl = this.dict[str];
    }
    return this.printf(transl, params);
  },
  printf: function(S, L) {
    if (!L) return S;
    var regex = /%s|{.+}/;
    /*var _r = function(p, c){
      return p.replace(regex, c);
    }*/
    return L.reduce(function(p, c){
      return p.replace(regex, c);
    }, S);
  }
}

export function setDict(dict, survLang=null){
  let lang = survLang? survLang: localStorage.getItem('uiLang');
  let langClass = lang == 'he'? 'rtl': 'ltr';
  document.body.classList.remove('ltr');
  document.body.classList.remove('rtl');
  document.body.classList.add(langClass);
  i18n.setDictionary(dict);
  i18n.setDictionary(dict);
}
export function _t(str, params){
  return i18n._(str, params);
}
